export const generateDoseOptions = (
    unitValues?: { id: string; name: string }[],
    form?: string,
): ((value: string) => { label: string; value: string; meta: any }[]) => {
    return (value) => {
        if (!value || !unitValues) {
            return [];
        }
        let pureInputValue = value;

        unitValues.forEach((p) => {
            const index = pureInputValue.toLowerCase().indexOf(p.name.toLowerCase());

            if (index > -1) {
                pureInputValue = pureInputValue.substr(0, index);
            }
        });

        const f = pureInputValue.trim();

        try {
            if (isFinite(eval(f)) && f.match('^[0-9.]+[/]?([0-9.]+)?$')) {
                return unitValues.map((pg) => ({
                    label: `${f} ${pg.name}`,
                    value: f.toString(),
                    meta: {
                        id: pg.id,
                        unit: pg.name,
                        formName: form,
                    },
                }));
            } else {
                return [];
            }
        } catch {
            return parseFloat(f)
                ? unitValues.map((pg) => ({
                      label: `${parseFloat(f)} ${pg.name}`,
                      value: parseFloat(f).toString(),
                      meta: {
                          id: pg.id,
                          unit: pg.name,
                          formName: form,
                      },
                  }))
                : [];
        }
    };
};
